import React from "react";
import "./TokenDistribution.css";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { useState, useCallback } from "react";
import { useEffect } from "react";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import ConvertTime from "../../Common/ConvertTime";
import { useNavigate } from "react-router-dom";
import { fetchAllSlots } from "../../Actions/adminActions";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import moment from "moment";
import debounce from "lodash.debounce";
import apiCall from "../../API/API";

const TokenDistribution = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { slots, loading } = useSelector((state) => state.admin);
  const [filter, setFilter] = useState("none");
  const [search, setsearch] = useState({
    slotId: "",
    status: "",
    slotName: "",
    activeStatus: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchSlots = useCallback(
    debounce((params) => {
      dispatch(fetchAllSlots(params));
    }, 500),
    [dispatch]
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setsearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
  };

  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "day").startOf("day").format("YYYY-MM-DD");
        end = today.subtract(1, "day").endOf("day").format("YYYY-MM-DD");
        break;
      case "last7days":
        start = today.subtract(7, "days").startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "last30days":
        start = today.subtract(30, "days").startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "thisMonth":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      case "lastMonth":
        start = today.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        end = today.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
    }
    setStartDate(start);
    setEndDate(end);
  };

  const Addfilter = () => {
    const params = {
      page: currentPage,
      limit: limitFilter,
      ...search,
      startDate,
      endDate,
    };
    fetchSlots(params);
  };

  const resetFilter = () => {
    setsearch({
      slotId: "",
      status: "",
      slotName: "",
      activeStatus: "",
    });
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    const params = {
      page: 1,
      limit: limitFilter,
    };
    setCurrentPage(1);
    fetchSlots(params);
  };

//   const getStatusBadge = (status) => {
//     const statusConfig = {
//       active: { variant: "success", text: "Active" },
//       inactive: { variant: "secondary", text: "Inactive" },
//       pending: { variant: "warning", text: "Pending" },
//       completed: { variant: "info", text: "Completed" }
//     };
    
//     const config = statusConfig[status] || { variant: "secondary", text: status };
//     return <span className={`badge bg-${config.variant}`}>{config.text}</span>;
//   };

//   const getProgressPercentage = (sold, total) => {
//     if (total === 0) return 0;
//     return Math.round((sold / total) * 100);
//   };

  useEffect(() => {
    const params = {
      page: currentPage,
      limit: limitFilter,
      ...search,
      startDate,
      endDate,
    };
    fetchSlots(params);
  }, [currentPage, limitFilter, search, startDate, endDate, fetchSlots]);

  useEffect(() => {
    if (slots && slots.data) {
      setTotalPages(Math.ceil(slots.total / limitFilter));
    }
  }, [slots, limitFilter]);

  return (
    <React.Fragment>
      <Container>
        <div className="pagePath">
          <p className="m-0">
           <span style={{fontSize: "25px", fontWeight: "bold"}}>Token Distribution</span>
          </p>
        </div>
        {/* <Row id="filterRow">
          <span id="filterLogo">
            <div className="d-flex justify-content-between">
              <div onClick={() => toggleFilter()}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
            </div>
            <div className="align-content-center">
              Total Slots: {slots?.total || 0}
            </div>
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="slotId"
                  placeholder="Search By Slot ID"
                  value={search.slotId}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="slotName"
                  placeholder="Search By Slot Name"
                  value={search.slotName}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="status"
                  value={search.status}
                  onChange={handleChange}
                >
                  <option value="">All Status</option>
                  <option value="LIVE">LIVE</option>
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="COMING SOON">COMING SOON</option>
                  <option value="UPCOMING">UPCOMING</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="activeStatus"
                  value={search.activeStatus}
                  onChange={handleChange}
                >
                  <option value="">All Active Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Date Filter</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last7days">Last 7 Days</option>
                  <option value="last30days">Last 30 Days</option>
                  <option value="thisMonth">This Month</option>
                  <option value="lastMonth">Last Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={Addfilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row> */}
        <div id="directTableRow">
          <table>
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Status</th>
                <th>Slot ID</th>
                <th>Sold Amount</th>
                <th>Total Amount</th>
                <th>Slot Name</th>
                {/* <th>Active Status</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : slots?.data && slots.data.length > 0 ? (
                slots.data.map((slot, index) => (
                  <tr key={index}>
                    <td>{((currentPage - 1) * limitFilter) + index + 1}</td>
                    <td>
                      {slot.status}
                    </td> 
                    <td>
                      <strong>{slot.slotId || slot.id}</strong>
                    </td>
                    <td>
                      {slot.sold_amount?.toLocaleString() || "0"}
                    </td>
                    <td>
                      {slot.total_amount?.toLocaleString() || "0"}
                    </td>
                    <td>
                      {slot.slot_name}
                    </td>
                    {/* <td>
                      {slot.active_status === "Active" ? "Active" : "Inactive"}
                    </td> */}
                    <td>
                    <button
                          className="block-btn"
                          onClick={() =>
                            navigate("/dashboard/update_slot", {
                              state: { slot: slot },
                            })
                          }
                        >
                          Update
                        </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    <p>No token slots found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* <Row>
          <Col md="12">
            {slots?.data && slots.data.length > 0 && (
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            )}
          </Col>
        </Row> */}
      </Container>
    </React.Fragment>
  );
};

export default TokenDistribution;
